(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[706],{

/***/ 82904:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/orders/order-status",
      function () {
        return __webpack_require__(57891);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ SHIPPED_TAB_VALUE; },
/* harmony export */   "B$": function() { return /* binding */ FULLORDER_TAB_VALUE; },
/* harmony export */   "Fx": function() { return /* binding */ ODP_ANALYTICS_ORDER_SUPPORT; },
/* harmony export */   "HP": function() { return /* binding */ SHIPPED_TAB_ANALYTICS; },
/* harmony export */   "Hl": function() { return /* binding */ ORDER_TYPE_SERVICE; },
/* harmony export */   "K6": function() { return /* binding */ CANCELLED_TAB_ANALYTICS; },
/* harmony export */   "L": function() { return /* binding */ SERVICES_SHIPPING_TYPE; },
/* harmony export */   "Pl": function() { return /* binding */ LINE_ITEM_STATUS_RETURN_REJECTED; },
/* harmony export */   "RS": function() { return /* binding */ ODP_ORDER_SUPPORT_EVENT; },
/* harmony export */   "UC": function() { return /* binding */ RETURNED_TAB_ANALYTICS; },
/* harmony export */   "Ur": function() { return /* binding */ LINE_ITEM_STATUS_RETURN_CANCELLED; },
/* harmony export */   "V0": function() { return /* binding */ TAB_ANALYTICS_EVENT; },
/* harmony export */   "Vz": function() { return /* binding */ FULLORDER_TAB_ANALYTICS; },
/* harmony export */   "X6": function() { return /* binding */ CANCELLED_TAB_VALUE; },
/* harmony export */   "YW": function() { return /* binding */ LINE_ITEM_STATUS_SHIPPED; },
/* harmony export */   "aK": function() { return /* binding */ ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME; },
/* harmony export */   "am": function() { return /* binding */ NON_SHIPPED_TABS; },
/* harmony export */   "b8": function() { return /* binding */ ORDER_TYPES_SORT_SEQUENCE; },
/* harmony export */   "cK": function() { return /* binding */ ODP_ANALYTICS_PAGE; },
/* harmony export */   "dm": function() { return /* binding */ LINE_ITEM_STATUS_CANCELLED; },
/* harmony export */   "dt": function() { return /* binding */ ODP_ANALYTICS_NAVIGATION; },
/* harmony export */   "f9": function() { return /* binding */ TABS_TO_SORT; },
/* harmony export */   "hW": function() { return /* binding */ ODP_ANALYTICS_ACCOUNT; },
/* harmony export */   "ik": function() { return /* binding */ INPROGRESS_TAB_ANALYTICS; },
/* harmony export */   "l4": function() { return /* binding */ LINE_ITEM_STATUS_RETURN_ACCEPTED; },
/* harmony export */   "mI": function() { return /* binding */ RETURN_STATUS_SORT_ORDER; },
/* harmony export */   "mJ": function() { return /* binding */ ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME; },
/* harmony export */   "mu": function() { return /* binding */ ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_POSITION; },
/* harmony export */   "rb": function() { return /* binding */ INPROGRESS_TAB_VALUE; },
/* harmony export */   "sN": function() { return /* binding */ LINE_ITEM_STATUS_INPROGRESS; },
/* harmony export */   "uN": function() { return /* binding */ LINE_ITEM_STATUS_RETURN_REQUESTED; },
/* harmony export */   "vy": function() { return /* binding */ RETURNED_TAB_VALUE; }
/* harmony export */ });
/* unused harmony exports ODP_CUSTOMER_SUPPORT_LINK_TYPE, LINE_ITEM_STATUS_RETURN_CREATED, ORDER_TYPE_PARCEL, ORDER_TYPE_FREIGHT */
const INPROGRESS_TAB_VALUE = "inprogress";
const FULLORDER_TAB_VALUE = "fullorder";
const SHIPPED_TAB_VALUE = "shipped";
const RETURNED_TAB_VALUE = "returned";
const CANCELLED_TAB_VALUE = "cancelled";
const FULLORDER_TAB_ANALYTICS = "Full Order";
const SHIPPED_TAB_ANALYTICS = "Shipped";
const INPROGRESS_TAB_ANALYTICS = "In Progress";
const RETURNED_TAB_ANALYTICS = "Returned";
const CANCELLED_TAB_ANALYTICS = "Cancelled";
const TAB_ANALYTICS_EVENT = "my account:orders:order details";
const ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME = "my account:orders:order details";
const ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME = "track package";
const ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_POSITION = "my account";
const ODP_ORDER_SUPPORT_EVENT = "my account:orders:order summary";
const ODP_ANALYTICS_PAGE = "orders";
const ODP_ANALYTICS_ACCOUNT = "my account";
const ODP_ANALYTICS_ORDER_SUPPORT = "order details:order support";
const ODP_ANALYTICS_NAVIGATION = "navigation";
const ODP_CUSTOMER_SUPPORT_LINK_TYPE = "order details:customer support";
const LINE_ITEM_STATUS_CANCELLED = "Cancelled";
const LINE_ITEM_STATUS_INPROGRESS = "In Progress";
const LINE_ITEM_STATUS_RETURN_CREATED = "Return Created";
const LINE_ITEM_STATUS_SHIPPED = "Shipped";
const LINE_ITEM_STATUS_RETURN_REQUESTED = "Return Requested";
const LINE_ITEM_STATUS_RETURN_ACCEPTED = "Return Accepted";
const LINE_ITEM_STATUS_RETURN_REJECTED = "Return Rejected";
const LINE_ITEM_STATUS_RETURN_CANCELLED = "Return Cancelled";
const ORDER_TYPE_PARCEL = "Parcel";
const ORDER_TYPE_FREIGHT = "Freight";
const ORDER_TYPE_SERVICE = "Service";
const TABS_TO_SORT = [
    SHIPPED_TAB_VALUE,
    INPROGRESS_TAB_VALUE,
    CANCELLED_TAB_VALUE
];
const NON_SHIPPED_TABS = [
    RETURNED_TAB_VALUE,
    INPROGRESS_TAB_VALUE,
    CANCELLED_TAB_VALUE
];
const RETURN_STATUS_SORT_ORDER = [
    LINE_ITEM_STATUS_RETURN_REQUESTED,
    LINE_ITEM_STATUS_RETURN_ACCEPTED,
    LINE_ITEM_STATUS_RETURN_REJECTED,
    LINE_ITEM_STATUS_RETURN_CANCELLED
];
const ORDER_TYPES_SORT_SEQUENCE = [
    ORDER_TYPE_PARCEL,
    ORDER_TYPE_FREIGHT,
    ORDER_TYPE_SERVICE
];
const SERVICES_SHIPPING_TYPE = [
    "INSTALL SERVICES",
    "DESIGN SERVICES"
];


/***/ }),

/***/ 18359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ND": function() { return /* binding */ getTabHeaders; },
/* harmony export */   "c3": function() { return /* binding */ handleInReviewContinueButton; },
/* harmony export */   "mk": function() { return /* binding */ getOrderDetailsTabs; }
/* harmony export */ });
/* harmony import */ var _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6055);

const getTotalQuantity = function() {
    let arr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return arr.reduce((total, item)=>{
        const itemQtySum = item.lineItems.reduce((sum, lineItem)=>{
            if (lineItem.childItems && lineItem.childItems.length > 0) {
                // sum the quantities of child items if they exist
                return sum + lineItem.childItems.reduce((childSum, child)=>{
                    return childSum + child.quantity;
                }, 0);
            } else {
                // otherwise, add the quantity of the line item itself
                return sum + lineItem.quantity;
            }
        }, 0);
        return total + itemQtySum;
    }, 0);
};
const getOrderDetailsTabs = (data, staticText)=>{
    const shippedItemsCount = getTotalQuantity(data[_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .SHIPPED_TAB_VALUE */ .$Q]);
    const inprogressItemsCount = getTotalQuantity(data[_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .INPROGRESS_TAB_VALUE */ .rb]);
    const returnedItemsCount = getTotalQuantity(data[_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .RETURNED_TAB_VALUE */ .vy]);
    const cancelledItemsCount = getTotalQuantity(data[_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .CANCELLED_TAB_VALUE */ .X6]);
    return [
        {
            label: staticText.fullorderTabLabel,
            value: _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .FULLORDER_TAB_VALUE */ .B$
        },
        {
            label: staticText.shippedTabLabel(shippedItemsCount),
            value: _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .SHIPPED_TAB_VALUE */ .$Q
        },
        {
            label: staticText.inprogressTabLabel(inprogressItemsCount),
            value: _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .INPROGRESS_TAB_VALUE */ .rb
        },
        {
            label: staticText.returnedTabLabel(returnedItemsCount),
            value: _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .RETURNED_TAB_VALUE */ .vy
        },
        {
            label: staticText.cancelledTabLabel(cancelledItemsCount),
            value: _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .CANCELLED_TAB_VALUE */ .X6
        }
    ];
};
const getTabHeaders = function() {
    let staticText = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tabname = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", lineItems = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    const hasLineitems = lineItems.length > 0;
    switch(tabname){
        case _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .CANCELLED_TAB_VALUE */ .X6:
            return {
                tabTitle: staticText.cancelledTabHeading,
                tabSubtitle: staticText.cancelledTabSubHeading,
                noItemsDescription: staticText.noItemsCancelledText,
                hasLineitems
            };
        case _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .INPROGRESS_TAB_VALUE */ .rb:
            return {
                tabTitle: staticText.inprogressTabHeading,
                tabSubtitle: staticText.inprogressTabSubHeading,
                noItemsDescription: staticText.noItemsInprogressText,
                hasLineitems
            };
        case _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .RETURNED_TAB_VALUE */ .vy:
            return {
                tabTitle: staticText.returnedTabHeading,
                tabSubtitle: staticText.returnedTabSubHeading,
                noItemsDescription: staticText.noItemsReturnedText,
                hasLineitems
            };
        default:
            return {
                tabTitle: "",
                tabSubtitle: "",
                noItemsDescription: "",
                hasLineitems: false
            };
    }
};
const handleInReviewContinueButton = (isMobile, phoneNumber, redirectUrl)=>{
    if (isMobile) {
        window.location.href = "tel:".concat(phoneNumber);
    } else {
        window.location.href = redirectUrl;
    }
};


/***/ }),

/***/ 48829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78145);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7872);
/* harmony import */ var _js_helperV2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30696);





const OrderInReviewModal = (props)=>{
    const { showAlert , handleClose , modalInfo: { modalTitle ="" , modalDescription ="" , buttonLabel ="" , buttonHandler =()=>{}  }  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "order-inreview-warning",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_2__["default"], {
            showModal: showAlert,
            onModalClose: ()=>handleClose(),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "order-inreview-warning__modal",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "order-inreview-warning__modal-title",
                        children: (0,_js_helperV2__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeText */ .oO)(modalTitle)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "order-inreview-warning__modal-desc",
                        children: (0,_js_helperV2__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeText */ .oO)(modalDescription)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "order-inreview-warning__modal-cta",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            className: "gbh-data-layer",
                            type: "black",
                            label: buttonLabel,
                            onClick: ()=>{
                                buttonHandler();
                            },
                            tag: "button"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OrderInReviewModal);


/***/ }),

/***/ 49599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78145);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7872);




const OrderWarning = (props)=>{
    const { showAlert , closeAlert , i18n: { orderWarningTitle , orderWarningDesc1 , orderWarningDesc2 , orderWarningContinueCta  }  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "orderWarning",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_2__["default"], {
            showModal: showAlert,
            onModalClose: ()=>closeAlert(false),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "order-warning__modal",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "order-warning__modal-title",
                        children: orderWarningTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "order-warning__modal-desc",
                        children: [
                            orderWarningDesc1,
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            orderWarningDesc2
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "order-warning__modal-cta",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            className: "gbh-data-layer",
                            type: "primary",
                            label: orderWarningContinueCta,
                            onClick: ()=>closeAlert(false),
                            tag: "button"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OrderWarning);


/***/ }),

/***/ 57891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ order_status; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx + 112 modules
var GlobalPageHeader = __webpack_require__(92058);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx
var GlobalPageFooter = __webpack_require__(10884);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 206 modules
var AemGrid = __webpack_require__(94020);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./components/core/ToolTip/ToolTip.jsx
var ToolTip = __webpack_require__(53683);
// EXTERNAL MODULE: ./components/Shared/OrderStatus/v1/OrderWarning.jsx
var OrderWarning = __webpack_require__(49599);
;// CONCATENATED MODULE: ./components/Shared/OrderStatus/v1/analytics/constant.js
const FIND_MY_ORDER_NUMBER = "where do i find my order number?";
const ORDER_STATUS = "order status";

;// CONCATENATED MODULE: ./components/Shared/OrderStatus/v1/analytics.js


const addFindMyOrderAnalytics = (params)=>{
    const { status , action , errorMessage , link  } = params;
    const eventInfo = getEventInfo("order status", "find my order", null, status, true, errorMessage, link);
    sessionStorage.setItem("searches", eventInfo.searchCount);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window.pageObj : getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: action,
        eventInfo,
        page
    });
    delete window.pageObj;
};
const getEventInfo = function(text1, text2, text3, status) {
    let needsJSON = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, errorsList = arguments.length > 5 ? arguments[5] : void 0, link = arguments.length > 6 ? arguments[6] : void 0;
    let errorMsg;
    if (status && status !== "success" && (errorsList === null || errorsList === void 0 ? void 0 : errorsList.length)) {
        errorMsg = errorsList.join("|").toLowerCase();
    }
    const eventInfo = {
        eventAction: "my account:orders:".concat(text1, ":").concat(text2),
        eventName: "my account:orders:".concat(text1, ":").concat(text2),
        eventType: text2 === "call support phone number" ? "help support" : "navigation",
        eventMsg: errorMsg || "n/a",
        eventStatus: status || "n/a",
        internalLinkName: text3 === null ? text2 : text3,
        internalLinkPosition: "my order",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:orders:".concat(text1),
        internalLinkURL: text3 === null ? link || "n/a" : "tel:" + text3,
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const getRecaptchaOrderStatusAnalytics = {
    pageTitle: "my account:orders:order status",
    componentName: "order status",
    parentComponent1: "orders",
    parentComponent2: "my account",
    internalLinkPosition: "my order",
    internalLinkType: "my account:navigation"
};
const handleHelpTextAnalytics = ()=>{
    const eventInfo = getEventInfo(ORDER_STATUS, FIND_MY_ORDER_NUMBER, null, null, true);
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo, "cmp:click");
};


// EXTERNAL MODULE: ./components/core/ReCaptcha/ReCaptcha.jsx + 1 modules
var ReCaptcha = __webpack_require__(46394);
// EXTERNAL MODULE: ./components/Shared/OrderInReviewModal/index.js
var OrderInReviewModal = __webpack_require__(48829);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./components/OrderConfirmation/OrderDetailsTabs/utils.js
var utils = __webpack_require__(18359);
;// CONCATENATED MODULE: ./components/Shared/OrderStatus/v1/OrderStatus.view.jsx














// import { log } from "@Services/logger.service"
const OrderStatus = (param)=>{
    let { i18n , cartcontactDetails =[] , ...props } = param;
    const { featureFlags ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { MYSQLCONNSTR_ENABLE_ORDER_DETAILS_TABS: isEnableTabView = false  } = featureFlags;
    const [showTooltip, setShowTooltip] = (0,react.useState)(false);
    const [data, setData] = (0,react.useState)({
        orderNo: {
            value: "",
            error: false,
            mssg: ""
        },
        email: {
            value: "",
            error: false,
            mssg: ""
        },
        error: {
            show: false,
            mssg: ""
        }
    });
    const [showAlert, setShowAlert] = (0,react.useState)(false);
    const statusAlert = (0,react.useRef)();
    const errorAlert = (0,react.useRef)();
    const { redirect , showToastMessage , inReviewModalInfo: { modalTitle ="" , modalDescription ="" , ctaPhoneNumber ="" , ctaRedirectingURL ="" , submittedModalTitle ="" , submittedModalDescription =""  } , isReceivedStatus , setIsReceived  } = props;
    (0,react.useEffect)(()=>{
        if (showTooltip) statusAlert.current.focus();
    }, [
        showTooltip
    ]);
    (0,react.useEffect)(()=>{
        if (data.error.show) errorAlert.current.focus();
    }, [
        data.error.show
    ]);
    const handleSubmit = async ()=>{
        var ref;
        let valid = true;
        const formData = {};
        const { email , orderNo  } = data;
        const errorMessage = [];
        if (!orderNo.value) {
            formData.orderNo = {
                ...orderNo,
                error: true,
                mssg: i18n.emptyOrderNo
            };
            valid = false;
            errorMessage.push(i18n.emptyOrderNo);
        }
        if (!email.value) {
            formData.email = {
                ...email,
                error: true,
                mssg: i18n.emptyEmail
            };
            valid = false;
            errorMessage.push(i18n.emptyEmail);
        } else if (!await (0,helper/* validateField */.OP$)("email", (ref = email.value) === null || ref === void 0 ? void 0 : ref.trim())) {
            formData.email = {
                ...email,
                error: true,
                mssg: i18n.validEmail
            };
            valid = false;
            errorMessage.push(i18n.validEmail);
        }
        setData({
            ...data,
            ...formData
        });
        if (valid) {
            (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
                if (res.success) {
                    props.findOrder(orderNo.value, email.value).then((check)=>{
                        if (check === "showWarning") {
                            setShowAlert(true);
                            // message for in progress status
                            addFindMyOrderAnalytics({
                                action: "cmp:click",
                                status: "failure",
                                resp: data,
                                errorMessage: [
                                    (0,helper/* sanitizeTextForAnalytics */.T68)(i18n.orderWarningDesc1),
                                    (0,helper/* sanitizeTextForAnalytics */.T68)(i18n.orderWarningDesc2)
                                ]
                            });
                        } else if (!check) {
                            setData({
                                ...data,
                                error: {
                                    show: true,
                                    mssg: i18n.cantFindOrder
                                }
                            });
                            errorMessage.push(i18n.cantFindOrder);
                            addFindMyOrderAnalytics({
                                action: "cmp:click",
                                status: "failure",
                                resp: data,
                                errorMessage: errorMessage
                            });
                        } else {
                            addFindMyOrderAnalytics({
                                action: "cmp:click",
                                status: "success",
                                resp: data,
                                link: check && typeof check === "string" ? (check.indexOf("http") === -1 ? window.location.origin : "") + check : null
                            });
                            // in case of success, we get url to redirect.
                            redirect(check);
                        }
                    }).catch((err)=>{
                        addFindMyOrderAnalytics({
                            action: "cmp:click",
                            status: "failure",
                            resp: data
                        });
                        // log.error(err)
                        console.error(err);
                    });
                } else {
                    showToastMessage({
                        message: i18n.genError,
                        isVisible: true
                    });
                }
            }).catch((error)=>{
                // log.error(err)
                console.error(error);
            });
        } else {
            addFindMyOrderAnalytics({
                action: "cmp:click",
                status: "failure",
                resp: data,
                errorMessage: errorMessage
            });
        }
    };
    const handleModalClose = ()=>{
        setIsReceived(false);
        setShowAlert(false);
    };
    const onBlurInput = async (e)=>{
        const { name  } = e.target;
        const formData = {};
        const { email , orderNo  } = data;
        if (name === "orderNo") {
            if (!orderNo.value) {
                formData.orderNo = {
                    ...orderNo,
                    error: true,
                    mssg: i18n.emptyOrderNo
                };
            }
        } else {
            var ref;
            if (!email.value) {
                formData.email = {
                    ...email,
                    error: true,
                    mssg: i18n.emptyEmail
                };
            } else if (!await (0,helper/* validateField */.OP$)("email", (ref = email.value) === null || ref === void 0 ? void 0 : ref.trim())) {
                formData.email = {
                    ...data.email,
                    error: true,
                    mssg: i18n.validEmail
                };
            }
        }
        setData({
            ...data,
            ...formData
        });
    };
    const modalInfo = {
        modalTitle: isReceivedStatus ? submittedModalTitle : modalTitle,
        modalDescription: isReceivedStatus ? submittedModalDescription : modalDescription,
        buttonLabel: isReceivedStatus ? (i18n === null || i18n === void 0 ? void 0 : i18n.orderSubmittedWarningCtaLabel) || "" : (i18n === null || i18n === void 0 ? void 0 : i18n.orderInReviewWarningContinueCta) || "",
        buttonHandler: isReceivedStatus ? handleModalClose : ()=>{
            (0,utils/* handleInReviewContinueButton */.c3)(lib/* isMobile */.tq, ctaPhoneNumber, ctaRedirectingURL);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "order-status container-fluid",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "row no-gutters",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-lg-12 order-status__form-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "order-status__banner",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "order-status__header",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "order-status__title",
                                        children: i18n.orderStatus
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "order-status__desc",
                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(i18n.orderStatusDesc)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "order-status__form",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "order-status__form-content",
                                children: [
                                    data.error.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: errorAlert,
                                        id: "kf-order-status-error",
                                        tabIndex: "0",
                                        role: "alert",
                                        className: "order-status__error-box",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: (0,helper/* sanitizeInnerHtml */.KD0)(data.error.mssg)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "kf-order-status-number",
                                        type: "text",
                                        name: "orderNo",
                                        value: data.orderNo.value,
                                        placeholder: "".concat(i18n.orderNo, "*"),
                                        label: "".concat(i18n.orderNo, "*"),
                                        onChange: (e)=>setData({
                                                ...data,
                                                orderNo: {
                                                    value: e.target.value,
                                                    error: false,
                                                    mssg: ""
                                                },
                                                error: {
                                                    show: false,
                                                    mssg: ""
                                                }
                                            }),
                                        showError: data.orderNo.error,
                                        errorMessage: data.orderNo.mssg,
                                        onBlur: onBlurInput
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "order-status__help-text",
                                        role: "link",
                                        tabIndex: "0",
                                        onClick: ()=>{
                                            setShowTooltip(!showTooltip);
                                            handleHelpTextAnalytics();
                                        },
                                        children: i18n.wheresOrderNo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "order-status__tooltip".concat(showTooltip ? "--show" : "--hide"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            ref: statusAlert,
                                            role: "tooltip",
                                            tabIndex: "0",
                                            "aria-label": i18n.tooltipMssg,
                                            id: "kf-order-status-tooltip",
                                            className: "order-status__tooltip-wrapper",
                                            onBlur: ()=>setShowTooltip(false),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                message: i18n.tooltipMssg
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "kf-order-status-email",
                                        type: "text",
                                        name: "email",
                                        maxLength: 60,
                                        value: data.email.value,
                                        placeholder: "".concat(i18n.email, "*"),
                                        label: "".concat(i18n.email, "*"),
                                        onChange: (e)=>setData({
                                                ...data,
                                                email: {
                                                    value: e.target.value,
                                                    error: false,
                                                    mssg: ""
                                                },
                                                error: {
                                                    show: false,
                                                    mssg: ""
                                                }
                                            }),
                                        showError: data.email.error,
                                        errorMessage: data.email.mssg,
                                        onBlur: onBlurInput
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        customClass: "order-status__find-btn",
                                        type: "black",
                                        flexible: true,
                                        label: i18n.findOrder,
                                        onClick: handleSubmit,
                                        tag: "button"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {
                                        getAnalyticsData: getRecaptchaOrderStatusAnalytics
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "order-status__support",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: i18n.needHelpOrder
                                            }),
                                            cartcontactDetails ? cartcontactDetails === null || cartcontactDetails === void 0 ? void 0 : cartcontactDetails.map((obj)=>{
                                                const { contactnumbertitle ="" , contactnumber =""  } = obj !== null && obj !== void 0 ? obj : {};
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "cart-info__brand-title",
                                                    children: [
                                                        contactnumbertitle,
                                                        ":   ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            "aria-label": "".concat(i18n.callSupport, " ").concat(contactnumber),
                                                            className: "cart-info__link gbh-data-layer",
                                                            href: "tel:".concat(contactnumber),
                                                            "data-gbh-data-layer": getEventInfo("order status", "call support phone number", contactnumber),
                                                            children: contactnumber
                                                        }, contactnumber)
                                                    ]
                                                }, contactnumbertitle);
                                            }) : null
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                showAlert ? isEnableTabView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderInReviewModal/* default */.Z, {
                    showAlert: showAlert,
                    modalInfo: modalInfo,
                    handleClose: handleModalClose
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderWarning/* default */.Z, {
                    showAlert: showAlert,
                    closeAlert: setShowAlert,
                    i18n: i18n
                }) : null
            ]
        })
    });
};
/* harmony default export */ var OrderStatus_view = (OrderStatus);

// EXTERNAL MODULE: ./utils/localization.js
var localization = __webpack_require__(64069);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
// EXTERNAL MODULE: ./utils/orders.js
var orders = __webpack_require__(79540);
;// CONCATENATED MODULE: ./components/Shared/OrderStatus/v1/OrderStatusFiller.jsx


const OrderStatusFiller = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "orderstatus",
            className: " aem-GridColumn aem-GridColumn--default--12",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "order-status container-fluid",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row no-gutters",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-lg-12 order-status__form-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-status__banner",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "order-status__header",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "order-status__title",
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "shimmer-loading__title shimmer"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "order-status__desc",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "shimmer-loading__para shimmer"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "shimmer-loading__para shimmer"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-status__form",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "order-status__form-content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "Input_inputFieldWrapper__nt6o0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " input-field ",
                                                id: "kf-order-status-number-wrapper",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "input-field__value",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "shimmer-loading__input shimmer"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                "aria-hidden": "true",
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "shimmer-loading__para shimmer"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "order-status__help-text gbh-data-layer",
                                            role: "link",
                                            tabIndex: "0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "shimmer-loading__para shimmer"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "Input_inputFieldWrapper__nt6o0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " input-field ",
                                                id: "kf-order-status-email-wrapper",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "input-field__value",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "shimmer-loading__input shimmer"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                "aria-hidden": "true",
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "shimmer-loading__para shimmer"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "Button_buttonWrapper__9Vvy_ kf-react-button button large black flexible order-status__find-btn ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "shimmer-loading__button shimmer"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "Recaptcha_reCatichWrapper__pIvbo",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-20 mb-20 recaptcha-links",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "gpolicies gbh-data-layer",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        href: "https://policies.google.com/privacy",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "gpolicies gbh-data-layer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "order-status__support",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "shimmer-loading__para shimmer"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "shimmer-loading__para shimmer"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var v1_OrderStatusFiller = (OrderStatusFiller);

// EXTERNAL MODULE: ./utils/index.js
var utils_0 = __webpack_require__(20558);
;// CONCATENATED MODULE: ./components/Shared/OrderStatus/v1/OrderStatus.jsx





















const OrderStatus_OrderStatus = (param)=>{
    let { data  } = param;
    var ref;
    // #ToDo Contact number needs to get from authdata
    const contactNumber = (ref = data === null || data === void 0 ? void 0 : data.contactnumber) !== null && ref !== void 0 ? ref : "NIL";
    const { cartcontactDetails =[] , modalDescription ="" , modalTitle ="" , ctaPhoneNumber ="" , ctaRedirectingURL ="" , submittedModalTitle ="" , submittedModalDescription =""  } = data !== null && data !== void 0 ? data : {};
    const inReviewModalInfo = {
        modalTitle,
        modalDescription,
        ctaPhoneNumber,
        ctaRedirectingURL,
        submittedModalTitle,
        submittedModalDescription
    };
    const { isAuth , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { isCartLoading =false  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [config, setInitialConfig] = (0,react.useState)({});
    const [isReceivedStatus, setIsReceivedStatus] = (0,react.useState)(false);
    const { homeUrl  } = config;
    const router = (0,next_router.useRouter)();
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const [i18n, seti18n] = (0,react.useState)({});
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            seti18n((0,localization/* getTranslations */.F)(t));
            setInitialState(config);
        });
        if (!isCartLoading) {
            dispatch((0,cartSlice/* setCardStatus */.YZ)(true));
            dispatch((0,cartSlice/* getCart */.dv)()).unwrap().then((rsp)=>{
                var ref;
                if ((rsp === null || rsp === void 0 ? void 0 : rsp.cartExists) && (rsp === null || rsp === void 0 ? void 0 : rsp.cartExists) === "false" && (rsp === null || rsp === void 0 ? void 0 : rsp.error) === "No active cart exists.") {
                    (0,helper/* getCurrency */.zC$)().then((currency)=>{
                        const cartPayload = {
                            currency: currency,
                            taxMode: "ExternalAmount"
                        };
                        dispatch((0,cartSlice/* createCart */.Bk)(cartPayload)).unwrap().then(()=>{
                            dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
                        });
                    });
                } else if (rsp === null || rsp === void 0 ? void 0 : (ref = rsp.lineItems) === null || ref === void 0 ? void 0 : ref.length) {
                    dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
                    const payload = {
                        actions: [
                            {
                                action: "recalculate",
                                updateProductData: true
                            }
                        ]
                    };
                    dispatch((0,cartSlice/* addToCart */.Xq)(payload));
                }
            });
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (user && isAuth && config.orderHistoryUrl) {
            router.push(config.orderHistoryUrl);
        }
    }, [
        user,
        isAuth,
        config.orderHistoryUrl
    ]);
    const setInitialState = async (config)=>{
        const homeUrl = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.homepageUrl", ""));
        const orderDetailsUrl = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.orderDetailsPath", ""));
        const orderHistoryUrl = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.orderHistoryPath", ""));
        setInitialConfig({
            homeUrl,
            orderDetailsUrl,
            orderHistoryUrl
        });
    };
    const redirect = (url)=>{
        router.push("".concat(url));
    };
    const showToastMessage = (payload)=>{
        dispatch((0,genericSlice/* showToast */.CF)(payload));
    };
    const findOrder = async (orderNo, email)=>{
        const res = await (0,orders/* fetchOrderDataByEmailOrderId */.lL)(email, orderNo);
        const { isEmailMatching , consumeFluentOrder , mainPayload ={} , results =[]  } = res;
        var ref;
        const { custom: { fields: { fraudChallengeStatus =""  } = {}  } = {}  } = (ref = results.find((o)=>{
            var ref, ref1;
            return (ref = o.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.isParentOrder;
        })) !== null && ref !== void 0 ? ref : {};
        if (consumeFluentOrder && !isEmailMatching) {
            return false;
        } else if (res) {
            if (!isEmpty_default()(mainPayload) || !isEmpty_default()(results)) {
                const { orderStatus =""  } = mainPayload;
                if (constants.FRAUD_CHLLENGE_STATUS.includes(fraudChallengeStatus) || constants.IN_REVIEW_ORDER_STATUS.includes(orderStatus) || constants.ORDER_IN_RECEIVED_STATUS.includes(orderStatus)) {
                    setIsReceivedStatus(constants.ORDER_IN_RECEIVED_STATUS.includes(orderStatus));
                    return "showWarning";
                } else {
                    return await (0,utils_0/* getOrderDetailsUrl */.e1)(email, orderNo);
                }
            }
            return false;
        } else return false;
    };
    return !isEmpty_default()(i18n) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderStatus_view, {
        i18n: i18n,
        homeUrl: homeUrl,
        supportLine: contactNumber,
        cartcontactDetails: cartcontactDetails,
        findOrder: (orderNo, email)=>findOrder(orderNo, email),
        redirect: redirect,
        showToastMessage: showToastMessage,
        inReviewModalInfo: inReviewModalInfo,
        isReceivedStatus: isReceivedStatus,
        setIsReceived: setIsReceivedStatus
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_OrderStatusFiller, {});
};
/* harmony default export */ var v1_OrderStatus = (OrderStatus_OrderStatus);

;// CONCATENATED MODULE: ./pages/orders/order-status.jsx










const OrderStatusPage = (param)=>{
    let { locale , tmpData: data , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analysticsScript , analyticsData , datalayerPageName , gbhDataLayerCustom  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        (0,helper/* getDataLayerObj */.C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* setDatalayerPageName */.dN)(datalayerPageName));
        dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        return ()=>{
            dispatch((0,genericSlice/* setDatalayerPageName */.dN)(""));
            dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader["default"], {
                themeType: data === null || data === void 0 ? void 0 : data.appliedCssClassNames,
                header: header,
                title: data.title,
                globalScripting: globalScript,
                analysticsScript: analysticsScript,
                data: data
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid["default"], {
                data: data,
                count: 0,
                orderStatus: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_OrderStatus, {
                        data: data
                    }),
                orderStatusFiller: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_OrderStatusFiller, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter["default"], {
                footer: footer,
                footerScripting: footerScript
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var order_status = (OrderStatusPage);


/***/ }),

/***/ 64069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
/* harmony import */ var _js_helperV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30696);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);


const getTranslations = function(t) {
    let authorData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        home: t("kf.global.label.home"),
        orderStatusDesc: t("kf.orderStatus.label.orderStatusDesc"),
        orderNo: t("kf.orderStatus.label.orderNo"),
        email: t("kf.orderConf.label.email"),
        wheresOrderNo: t("kf.orderStatus.label.wheresOrderNo"),
        tooltipMssg: t("kf.orderStatus.label.tooltipMssg"),
        findMyOrder: t("kf.orderStatus.label.findMyOrder"),
        callSupport: t("kf.orderDetails.label.callSupport"),
        emptyOrderNo: t("kf.orderStatus.label.emptyOrderNo"),
        validOrderNo: t("kf.orderStatus.label.validOrderNo"),
        emptyEmail: t("kf.orderStatus.label.emptyEmail"),
        validEmail: t("kf.orderStatus.label.validEmail"),
        cantFindOrder: t("kf.orderStatus.label.cantFindOrder"),
        genError: t("kf.error.message.genericError"),
        orderWarningDesc1: t("kf.orderStatus.message.orderWarningDesc1"),
        orderWarningDesc2: t("kf.orderStatus.message.orderWarningDesc2"),
        orderWarningTitle: t("kf.orderStatus.label.orderWarningTitle"),
        orderWarningContinueCta: t("kf.orderStatus.button.orderWarningContinueCta"),
        orderInReviewWarningContinueCta: t("kf.orderStatus.button.orderInReviewWarningContinueCta"),
        orderSubmittedWarningCtaLabel: t("kf.orderStatus.button.orderSubmittedWarningCtaLabel"),
        order: t("kf.orderHistory.label.order"),
        orderDetails: t("kf.orderDetails.label.orderDetails"),
        orderPlacedOn: t("kf.orderDetails.label.orderPlacedOn"),
        customerInfo: t("kf.orderDetails.label.customerInfo"),
        contactInfo: t("kf.orderDetails.label.contactInfo"),
        shippingAddress: t("kf.orderDetails.label.shippingAddress"),
        paymentInfo: t("kf.orderDetails.label.paymentInfo"),
        billingAddress: t("kf.orderDetails.label.billingAddress"),
        endingIn: t("kf.orderDetails.label.endingIn"),
        expiry: t("kf.orderDetails.label.expiry"),
        print: t("kf.orderDetails.label.print"),
        downloadSpecs: t("kf.orderDetails.label.downloadSpecs"),
        needHelp: t("kf.orderDetails.label.needHelp"),
        supportDesc1: t("kf.orderDetails.label.supportDesc1"),
        returnPolicy: t("kf.orderDetails.label.returnPolicy"),
        or: t("kf.orderDetails.label.or"),
        productWarranty: t("kf.orderDetails.label.productWarranty"),
        supportDesc2: t("kf.orderDetails.label.supportDesc2"),
        orderSummary: t("kf.orderDetails.label.orderSummary"),
        subTotal: t("kf.orderDetails.label.subTotal"),
        totalPromotions: t("kf.orderDetails.label.totalPromotions"),
        shipping: t("kf.orderDetails.label.shipping"),
        taxes: t("kf.orderDetails.label.taxes"),
        orderNumber: t("kf.orderDetails.label.orderNumber"),
        qty: t("kf.cart.label.qty"),
        quantity: t("kf.checkout.label.quantity"),
        unitPrice: t("kf.cart.label.unitPrice"),
        total: t("kf.cart.label.total"),
        colorFinish: t("kf.cart.label.colorFinish"),
        parcelShipping: t("kf.orderDetails.label.parcelShipping"),
        freightShipping: t("kf.orderDetails.label.freightShipping"),
        registerProducts: t("kf.orderDetails.label.registerProducts"),
        createReturn: t("kf.orderDetails.label.createReturn"),
        tracking: t("kf.orderDetails.label.tracking"),
        allItemsCancelled: t("kf.orderDetails.label.allItemsCancelled"),
        fewItemsCancelled: t("kf.orderDetails.label.fewItemsCancelled"),
        note: t("kf.cart.label.note"),
        comboSkuMssg: t("kf.cart.label.comboSkuMssg"),
        eDelivery: t("kf.cart.label.eDelivery"),
        eDeliveryNote: t("kf.orderDetails.label.eDeliveryNote"),
        eDeliveryMsg: t("kf.orderDetails.label.eDeliveryMsg"),
        viewPartsDiagram: t("kf.orderDetails.label.viewPartsDiagram"),
        noOrderFound: t("kf.orderConf.label.noOrderFound"),
        printAria: t("kf.orderDetails.label.printAria"),
        comboSkuDelivery: t("kf.orderDetails.label.comboSkuDelivery"),
        parcelTooltip: t("kf.orderDetails.label.parcelTooltip"),
        parcelShippingAriaLabel: t("kf.checkout.label.parcelShippingAriaLabel"),
        freightTooltip: t("kf.orderDetails.label.freightTooltip"),
        eDeliveryTooltip: t("kf.orderDetails.label.eDeliveryTooltip"),
        discountPercentage: t("kf.checkout.label.discountPercentage"),
        off: t("kf.cart.label.off"),
        ariaLabel: {
            partsDiagram: (product)=>t("kf.myProducts.aria.label.partsDiagram", {
                    product
                }),
            currentPage: t("kf.pdp.label.aria.currentPage"),
            page: t("kf.pdp.label.aria.page")
        },
        openNewTabText: t("kf.share.label.openNewTabText"),
        backOrderMssg: (days)=>t("kf.cart.label.backOrderMssg", {
                days
            }),
        cancelled: t("kf.orderDetails.label.cancelled"),
        hi: t("kf.account.label.hi"),
        signOut: t("kf.account.label.signOut"),
        myAccount: t("kf.account.label.myAccount"),
        favorites: t("kf.account.label.favorites"),
        myLists: t("kf.account.label.myLists"),
        accountSettings: t("kf.account.label.accountSettings"),
        myProducts: t("kf.account.label.myProducts"),
        myServices: t("kf.account.label.myServices"),
        ariaSignOut: t("kf.loggedin.button.aria.signOut"),
        menuItems: (pageName)=>t("kf.account.aria.menuItems", {
                pageName
            }),
        orders: t("kf.orderHistory.label.orders"),
        openOrders: t("kf.orderHistory.label.openOrders"),
        pastOrders: t("kf.orderHistory.label.pastOrders"),
        orderPlacedOnHistory: t("kf.orderHistory.label.orderPlacedOn"),
        items: t("kf.orderHistory.label.items"),
        orderTotal: t("kf.orderHistory.label.orderTotal"),
        orderStatus: t("kf.orderHistory.label.orderStatus"),
        viewOrder: t("kf.orderHistory.label.viewOrder"),
        continueShopping: t("kf.orderHistory.label.continueShopping"),
        noOpenOrders: t("kf.orderHistory.label.noOpenOrders"),
        loading: t("kf.search.label.loading"),
        orderCreatedOn: (showOrdersFromLabel)=>showOrdersFromLabel ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeDOMString */ .TRt)(showOrdersFromLabel) : t("kf.orderHistory.label.orderCreatedOn"),
        thankYouForOrder: t("kf.orderConf.label.thankYouForOrder"),
        freeShipping: t("kf.label.freeShipping"),
        orderConfMessage: t("kf.orderConf.label.orderConfMessage"),
        emailMessage: t("kf.orderConf.label.emailMessage"),
        orderConfirmation: t("kf.orderConf.label.orderConfirmation"),
        orderConfirmationNumber: t("kf.orderConf.label.orderConfirmationNumber"),
        supportDesc: t("kf.orderDetails.label.supportDesc"),
        parcelShippingDesc: (days)=>{
            return (authorData === null || authorData === void 0 ? void 0 : authorData.parcelMessage) ? (0,_js_helperV2__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeText */ .oO)(authorData.parcelMessage.replace("{{days}}", days)) : t("kf.orderDetails.label.parcelShippingDesc", {
                days
            });
        },
        freightShippingDesc: (days)=>{
            return (authorData === null || authorData === void 0 ? void 0 : authorData.freightMessage) ? (0,_js_helperV2__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeText */ .oO)(authorData.freightMessage.replace("{{days}}", days)) : t("kf.orderDetails.label.freightShippingDesc", {
                days
            });
        },
        eDeliveryDesc: (days)=>{
            return (authorData === null || authorData === void 0 ? void 0 : authorData.eDeliveryMessage) ? (0,_js_helperV2__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeText */ .oO)(authorData.eDeliveryMessage.replace("{{days}}", days)) : t("kf.cart.label.eDeliveryDesc", {
                days
            });
        },
        itemOf: (index, count)=>t("kf.orderDetails.label.itemOf", {
                index,
                count
            }),
        childOrderStatus: t("kf.orderDetails.label.childOrderStatus"),
        productDiscounts: t("kf.cart.label.productDiscounts"),
        shipmentOf: (number, total)=>t("kf.orderDetails.label.shipmentOf", {
                number,
                total
            }),
        homeowner: t("kf.auth.label.homeOwner"),
        professional: t("kf.auth.label.professional"),
        viewOrderDetails: t("kf.orderHistory.label.viewOrder"),
        createPassword: t("kf.account.label.createPassword"),
        password: t("kf.account.label.password"),
        passwordRequirements: t("kf.auth.label.passwordRequirements"),
        show: t("kf.auth.label.show"),
        hide: t("kf.auth.label.hide"),
        characterCount: t("kf.auth.label.characterCount"),
        uppercaseLetter: t("kf.auth.label.uppercaseLetter"),
        lowercaseLetter: t("kf.auth.label.lowercaseLetter"),
        symbolValidation: t("kf.auth.label.symbolValidation"),
        numberValidation: t("kf.auth.label.numberValidation"),
        pwMustInclude: t("kf.auth.label.pwMustInclude"),
        accountType: t("kf.account.label.accountType"),
        passwordError: t("kf.auth.error.passwordError"),
        passwordProvideError: t("kf.auth.label.provide.pwdError"),
        accountCreationWelcomeAria: t("kf.auth.label.welcomeAria"),
        downloadSpecSheet: t("kf.orderdetails.lable.downloadSpecSheet"),
        printOrderDetail: t("kf.orderdetails.lable.printOrderDetail"),
        needHelpOrder: t("kf.cart.label.needHelpOrder"),
        findOrder: t("kf.orderStatus.label.findOrder"),
        openTill: t("kf.findstore.label.openTill")
    };
};


/***/ }),

/***/ 79540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AU": function() { return /* binding */ fetchOrders; },
/* harmony export */   "K0": function() { return /* binding */ setMenu; },
/* harmony export */   "ZI": function() { return /* binding */ getCardDetails; },
/* harmony export */   "lL": function() { return /* binding */ fetchOrderDataByEmailOrderId; }
/* harmony export */ });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _store_features_orderSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76977);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88032);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64757);







const getCardDetails = async (param)=>{
    let { url , cardId  } = param;
    try {
        var ref;
        const serviceList = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance */ .Gb)({
            url: _constants__WEBPACK_IMPORTED_MODULE_2__.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: url
            }
        });
        if (serviceList === null || serviceList === void 0 ? void 0 : (ref = serviceList.data) === null || ref === void 0 ? void 0 : ref.cardTypes) {
            var ref1;
            const cardTypesList = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance */ .Gb)({
                url: _constants__WEBPACK_IMPORTED_MODULE_2__.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: serviceList === null || serviceList === void 0 ? void 0 : (ref1 = serviceList.data) === null || ref1 === void 0 ? void 0 : ref1.cardTypes
                }
            });
            if (cardTypesList && cardTypesList.data) {
                var ref2, ref3;
                var ref4;
                const cardValueText = (ref4 = (ref3 = cardTypesList === null || cardTypesList === void 0 ? void 0 : (ref2 = cardTypesList.data) === null || ref2 === void 0 ? void 0 : ref2.find((card)=>card.value === cardId)) === null || ref3 === void 0 ? void 0 : ref3.text) !== null && ref4 !== void 0 ? ref4 : "";
                return cardValueText;
            } else {
            // log.error(
            //   "Card Details: Error occured while fetching data from AEM"
            // )
            }
        }
    } catch (error) {
    // log.error(error)
    }
};
const setMenu = function(info, i18n, language) {
    let isSaveProductToList = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    const { accountSettingsPath , myFavoritesPagePath , orderHistoryPath , myProductsPath , myServicesPath  } = info;
    const urlsAndTitles = [
        {
            url: accountSettingsPath,
            title: i18n.accountSettings
        },
        {
            url: isSaveProductToList ? "/".concat(language).concat(_constants_routes__WEBPACK_IMPORTED_MODULE_5__/* .MY_LISTS_PAGE_PATH */ .PN) : myFavoritesPagePath,
            title: isSaveProductToList ? i18n.myLists : i18n.favorites
        },
        {
            url: orderHistoryPath,
            title: i18n.orders
        },
        {
            url: myProductsPath,
            title: i18n.myProducts
        },
        {
            url: myServicesPath,
            title: i18n.myServices
        }
    ];
    return urlsAndTitles.filter((param)=>{
        let { url  } = param;
        return url;
    }).map((param)=>{
        let { url , title  } = param;
        return {
            title,
            url
        };
    });
};
const getDaysDifference = (orderDate)=>{
    const currentDate = new Date();
    const timeDiff = orderDate.getTime() - currentDate.getTime();
    const daysDiff = timeDiff / _constants__WEBPACK_IMPORTED_MODULE_2__.TotalSecsForaDay;
    return daysDiff;
};
const fetchOrders = async ()=>{
    // #ToDo Make loading true
    const openOrders = [];
    const pastOrders = [];
    let postOrdersForUpsell = [];
    const openData = await _store__WEBPACK_IMPORTED_MODULE_4__/* .store.dispatch */ .h.dispatch((0,_store_features_orderSlice__WEBPACK_IMPORTED_MODULE_3__/* .getOpenOrders */ .x0)()).unwrap().then((response)=>response);
    const pastData = await _store__WEBPACK_IMPORTED_MODULE_4__/* .store.dispatch */ .h.dispatch((0,_store_features_orderSlice__WEBPACK_IMPORTED_MODULE_3__/* .getPastOrders */ .rx)()).unwrap().then((response)=>response);
    openData.forEach((order)=>{
        var ref, ref1;
        const orderDate = new Date(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "createdAt", ""));
        const openDataArr = (ref = order.lineItems) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
            var ref, ref1;
            return !((ref = item.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.find((attr)=>attr.name === "ComboSKU"));
        });
        const lineItemsData = (ref1 = order.lineItems) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>{
            var ref, ref1;
            return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
        });
        const daysDiff = getDaysDifference(orderDate);
        openOrders.push({
            orderNo: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "orderNumber", ""),
            totalItems: openDataArr.reduce((a, b)=>{
                return a + b.quantity;
            }, 0),
            orderStatus: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "state.obj.name.en-US", ""),
            orderDate: "".concat(orderDate.toLocaleString("default", {
                month: "long"
            }), " ").concat(orderDate.getDate(), ", ").concat(orderDate.getFullYear()),
            orderTotal: Number(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "taxedPrice.totalGross.centAmount", 0) / 100).toFixed(2),
            lineItems: daysDiff < _constants__WEBPACK_IMPORTED_MODULE_2__.postOrderNoOfDays ? lineItemsData : []
        });
    });
    pastData.forEach((order)=>{
        var ref, ref1;
        const orderDate = new Date(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "createdAt", ""));
        const pastDataArr = (ref = order.lineItems) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
            var ref, ref1;
            return !((ref = item.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.find((attr)=>attr.name === "ComboSKU"));
        });
        const lineItemsData = (ref1 = order.lineItems) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>{
            var ref, ref1;
            return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
        });
        const daysDiff = getDaysDifference(orderDate);
        pastOrders.push({
            orderNo: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "orderNumber", ""),
            totalItems: pastDataArr.reduce((a, b)=>{
                return a + b.quantity;
            }, 0),
            orderStatus: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "state.obj.name.en-US", ""),
            orderDate: "".concat(orderDate.toLocaleString("default", {
                month: "long"
            }), " ").concat(orderDate.getDate(), ", ").concat(orderDate.getFullYear()),
            orderTotal: Number(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "taxedPrice.totalGross.centAmount", 0) / 100).toFixed(2),
            lineItems: daysDiff < _constants__WEBPACK_IMPORTED_MODULE_2__.postOrderNoOfDays ? lineItemsData : []
        });
    });
    const placedOrders = openOrders.concat(pastOrders);
    if (placedOrders.length) {
        postOrdersForUpsell = placedOrders.filter((item)=>item.orderStatus !== "Cancelled").map((item)=>item.lineItems).flat(1);
    }
    return {
        openOrders,
        pastOrders,
        postOrdersForUpsell
    };
};
/**
 *
 * @param {String} email
 * @param {String} orderNo
 * @return {String} order details page url
 */ const fetchOrderDataByEmailOrderId = async (email, orderNo)=>{
    return await _store__WEBPACK_IMPORTED_MODULE_4__/* .store.dispatch */ .h.dispatch((0,_store_features_orderSlice__WEBPACK_IMPORTED_MODULE_3__/* .findOrderByEmail */ .Jv)({
        orderNo,
        email
    })).unwrap().then((response)=>response);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(82904); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);